import React from 'react'
import styled from 'styled-components'

import { Heading2, Heading4 } from '../../styles/Text'

const Heading = styled(Heading2)`
  margin-bottom: 32px;
`

const Subheading = styled(Heading4)`
  margin-bottom: 16px;
`

const ColourSection = styled.div`
  :not(:last-child) {
    margin-bottom: 40px;
  }
`

const ColourRow = styled.div`
  display: flex;
  column-gap: 10px;
  :not(:last-child) {
    margin-bottom: 8px;
  }
`

const ColourItem = styled.div`
  width: 100%;
  padding: 10px;
  background-color: ${(p) => p.colour};
  font-weight: 500;
  font-size: 16px;
  line-height: 172%;
  ${(p) => p.textColour && `color: ${p.textColour};`}
`

const Colour = () => {
  return (
    <>
      <Heading>Colour</Heading>
      <Subheading>Pusher</Subheading>
      <ColourSection>
        <ColourRow>
          <ColourItem colour="#300D4F" textColour="white">
            #300D4F
          </ColourItem>
          <ColourItem colour="#916AFF" textColour="white">
            #916AFF
          </ColourItem>
        </ColourRow>
        <ColourRow>
          <ColourItem colour="#6825B1" textColour="white">
            #6825B1
          </ColourItem>
          <ColourItem colour="#E6E2FC">#E6E2FC</ColourItem>
          <ColourItem colour="#F0F1F6">#F0F1F6</ColourItem>
          <ColourItem colour="#FF8DE3">#FF8DE3</ColourItem>
        </ColourRow>
      </ColourSection>
      <Subheading>Channels</Subheading>
      <ColourSection>
        <ColourRow>
          <ColourItem colour="#5D2BE7" textColour="white">
            #5D2BE7
          </ColourItem>
          <ColourItem colour="#C7B9FF">#C7B9FF</ColourItem>
          <ColourItem colour="#221838" textColour="white">
            #221838
          </ColourItem>
        </ColourRow>
      </ColourSection>
      <Subheading>Beams</Subheading>
      <ColourSection>
        <ColourRow>
          <ColourItem colour="#40F2AF">#40F2AF</ColourItem>
          <ColourItem colour="#1A2420" textColour="white">
            #1A2420
          </ColourItem>
          <ColourItem colour="#173138" textColour="white">
            #173138
          </ColourItem>
        </ColourRow>
      </ColourSection>
    </>
  )
}

export default Colour
